import { render } from "./Edit75Liquidation3.vue?vue&type=template&id=8168dedc"
import script from "./Edit75Liquidation3.vue?vue&type=script&lang=js"
export * from "./Edit75Liquidation3.vue?vue&type=script&lang=js"

import "./Edit75Liquidation3.vue?vue&type=style&index=0&id=8168dedc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__